export namespace IFaireAcademyChapter {
  export enum ChapterIdentifier {
    CHAPTER_IDENTIFIER_UNKNOWN = 'CHAPTER_IDENTIFIER_UNKNOWN',
    YOUR_CONCEPT_AND_VISION = 'YOUR_CONCEPT_AND_VISION',
    FINDING_YOUR_SUPPORT_NETWORK = 'FINDING_YOUR_SUPPORT_NETWORK',
    WRITING_A_BUSINESS_PLAN = 'WRITING_A_BUSINESS_PLAN',
    TYPES_OF_FUNDING = 'TYPES_OF_FUNDING',
    REGISTERING_YOUR_BUSINESS = 'REGISTERING_YOUR_BUSINESS',
    BUDGETING = 'BUDGETING',
    YOUR_STORE_LOCATION = 'YOUR_STORE_LOCATION',
    SIGNING_A_LEASE = 'SIGNING_A_LEASE',
    PERMITS = 'PERMITS',
    PLANNING_YOUR_LAYOUT = 'PLANNING_YOUR_LAYOUT',
    ASSESSING_NECESSARY_WORK = 'ASSESSING_NECESSARY_WORK',
    BUDGETING_RENOVATIONS = 'BUDGETING_RENOVATIONS',
    PRE_BUILD_LABOR_AND_MATERIALS = 'PRE_BUILD_LABOR_AND_MATERIALS',
    POST_BUILD_INSPECTIONS = 'POST_BUILD_INSPECTIONS',
    FURNISHINGS = 'FURNISHINGS',
    PLANNING = 'PLANNING',
    FINANCING = 'FINANCING',
    SOURCING_AND_BUYING = 'SOURCING_AND_BUYING',
    MERCHANDISING = 'MERCHANDISING',
    POINT_OF_SALE_SYSTEMS = 'POINT_OF_SALE_SYSTEMS',
    INSURANCE = 'INSURANCE',
    STAFFING = 'STAFFING',
    PAYROLL = 'PAYROLL',
    BUILDING_A_WEBSITE = 'BUILDING_A_WEBSITE',
    MARKETING = 'MARKETING',
    YOUR_GRAND_OPENING = 'YOUR_GRAND_OPENING',
  }

  export enum ChapterLikeStatus {
    CHAPTER_LIKE_STATUS_UNKNOWN = 'CHAPTER_LIKE_STATUS_UNKNOWN',
    LIKED = 'LIKED',
    DISLIKED = 'DISLIKED',
  }

  /**
   * Return an instance of IFaireAcademyChapter with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IFaireAcademyChapter>
  ): IFaireAcademyChapter =>
    ({
      ...(partial ?? {}),
    }) as IFaireAcademyChapter;
}

export interface IFaireAcademyChapter {
  identifier: keyof typeof IFaireAcademyChapter.ChapterIdentifier | undefined;
  is_read: boolean | undefined;
  is_liked: boolean | undefined;
  reading_time_in_minutes: number | undefined;
  chapter_url: string | undefined;
  title: string | undefined;
}
